import React, { useId } from 'react';
import './GlobalSearchInput.css';

const GlobalSearchInput = ({
  value,
  onChange,
  placeholder = 'Buscar...',
  label,
  className = '',
  inputId,
  disabled = false,
}) => {
  const generatedId = useId();
  const resolvedId = inputId || generatedId;

  return (
    <div className={`global-search ${className}`.trim()}>
      {label ? (
        <label className="global-search-label" htmlFor={resolvedId}>
          {label}
        </label>
      ) : null}

      <div className="global-search-control">
        <i className="fas fa-search global-search-icon"></i>
        <input
          id={resolvedId}
          type="text"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className="global-search-input"
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default GlobalSearchInput;
